import type { AdCreativeItem } from '@segmently/schema-models/ad-creative';

export interface CreateAdCreativeManifestVariationRequest {
  projectId: string;
  sourceCreativeItemId: string;
  sourceExportManifestId: string;
  sourceExportedManifestHash: string;
  sourceRenditionId: string;
  sourceLocale: string;
  sourceDeploymentKey: string;
  sourceProvider: 'meta' | 'google_ads' | 'tiktok_ads';
  sourceProviderAccountId: string;
  sourceProviderResourceName: string;
  sourceProviderMutationAllowed: false;
  sourceReviewRequired: true;
  sourceLocalizationVariantId?: string;
}

export interface CreateAdCreativeManifestVariationResponse {
  success: boolean;
  data?: {
    item: AdCreativeItem;
    reused: boolean;
    sourceProviderMutationAllowed: false;
    reviewRequired: true;
    providerMutationCount: 0;
  };
  error?: string;
  code?: string;
}

export function buildManifestVariationCall(request: CreateAdCreativeManifestVariationRequest): {
  path: string;
  method: 'POST';
  projectId: string;
  body: Omit<CreateAdCreativeManifestVariationRequest, 'sourceCreativeItemId'>;
} {
  const { sourceCreativeItemId, ...body } = request;
  return {
    path: `/api/agent/ad-creative/items/${encodeURIComponent(sourceCreativeItemId)}/create-variation-from-manifest`,
    method: 'POST',
    projectId: request.projectId,
    body,
  };
}
